import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-icon-toggle-theme-light',
  templateUrl: './icon-toggle-theme.component.html',
  styleUrl: '../icon-shared/icon-shared.scss'
})
export class IconToggleThemeLightComponent {
    @Input() isActive: boolean = false;
}
